import { ProductCategory } from '../../../types/ProductCategory';

const sortByCategory = (categories: typeof ProductCategory): ((a: string, b: string) => number) => {
    const orderedCategories = Object.values(categories).reduce((acc, cv, index) => {
        acc[cv] = index;
        return acc;
    }, {});

    return (a, b) => orderedCategories[a] - orderedCategories[b];
};

export const sortCategory = sortByCategory(ProductCategory);
